import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  const isAuthenticated = false;

  return isAuthenticated ? <Navigate to="/main" /> : children;
}
